import ChatBubbleIcon from "@uui/MessageChatSquare";
import { useParams } from "react-router-dom";

import { Stack } from "@mui/material";

import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";
import useReportShare from "@app/common/access/ShareReport/hooks/useReportShare";
import { hasRecapOnlyAccess } from "@app/common/access/ShareReport/utils";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";

const FilteredContent = () => {
  const clearSpeakerFilters = useTranscriptStore(
    (state) => state.clearSpeakerFilters
  );

  return (
    <>
      <EmptyStateTitle>Nothing to see here</EmptyStateTitle>
      <EmptyStateSubtext>
        Oops, there are no transcript turns to show for the selected filters.
        Try removing filters to see more.
      </EmptyStateSubtext>
      <Button variant="gradient" onClick={clearSpeakerFilters}>
        Remove filters
      </Button>
    </>
  );
};

const NoContent = () => (
  <>
    <EmptyStateTitle>Nothing to see here</EmptyStateTitle>
    <EmptyStateSubtext>
      Transcription was not enabled or there was no speech detected.
    </EmptyStateSubtext>
  </>
);

export const TranscriptUnauthorized = () => {
  const { sessionId } = useParams();
  const { accessList } = useReportShare({ sessionId: sessionId! });
  return (
    <>
      <EmptyStateTitle>No transcript</EmptyStateTitle>
      <EmptyStateSubtext>
        Transcription is disabled for your Workspace.
      </EmptyStateSubtext>
      {!hasRecapOnlyAccess(accessList.currentUserAccessLevel) && (
        <Link to={ROUTES.meetingReportTabById(sessionId!, "deep-dive")}>
          <Button variant="gradient">View Deep Dive</Button>
        </Link>
      )}
    </>
  );
};

const EmptyTranscript = ({
  type,
}: {
  type: "default" | "filter" | "unauthorized";
}) => (
  <Stack sx={{ pt: 1 }}>
    <EmptyStateContainer>
      <EmptyStateIcon Icon={ChatBubbleIcon} />
      {type === "filter" ? (
        <FilteredContent />
      ) : type === "unauthorized" ? (
        <TranscriptUnauthorized />
      ) : (
        <NoContent />
      )}
    </EmptyStateContainer>
  </Stack>
);

export default EmptyTranscript;
